import { CSS3DObject } from 'three/examples/jsm/renderers/CSS3DRenderer.js'
import { Vector3 } from 'three'

const vector3 = new Vector3()

// :style="{transform: `translate3d( ${transformation.x}%, ${transformation.y}%, ${transformation.z}px)`}"

export default {
  props: {
    lookAt: {
      type: Object,
      default: () => {
        return {
          x: 0,
          y: 0,
          z: 0
        }
      }
    },
    position: {
      type: Object,
      default: () => {
        return {
          x: 0,
          y: 0,
          z: 0
        }
      }
    },
    transformation: {
      type: Object,
      default: () => {
        return {
          x: 0,
          y: 0,
          z: 0
        }
      }
    },
    rotation: {
      type: Object,
      default: () => {
        return {
          x: 0,
          y: 0,
          z: 0
        }
      }
    }
  },

  mounted () {
    this.object = new CSS3DObject(this.$el)
    this.$dom3d.addObject(this.object)

    this._placeObject()
    this._rotateObject()
  },

  methods: {
    _placeObject () {
      this.object.position.x = this.position.x * 10
      this.object.position.y = this.position.y * 10
      this.object.position.z = this.position.z * 10
    },
    getMatrice () {
      const size = this.$el.getBoundingClientRect()
      return {
        width: size.width,
        height: size.height,
        ratio:  size.width / this.$el.offsetWidth
      }
    },
    _rotateObject () {
      this.object.rotation.x = this.rotation.x
      this.object.rotation.y = this.rotation.y
      this.object.rotation.z = this.rotation.z
    },
    _lookAt () {
      this.object.lookAt(
        this.lookAt.x * 10,
        this.lookAt.y * 10,
        this.lookAt.z * 10
      )
    }
  },

  destroyed () {
    this.$dom3d.removeObject(this.object)
  },

  watch: {
    lookAt: {
       handler() {
         this._lookAt()
       },
       deep: true
    },
    position: {
       handler() {
         this._placeObject()
       },
       deep: true
    },
    rotation: {
       handler(val){
         this._rotateObject()
       },
       deep: true
    }
  }
}
